
<template>
  <v-container fill-height align-start>
    <v-row justify="center" class="pt-8">
      <v-col cols="12" align="center">
        <span :class="`${$vuetify.breakpoint.smAndDown?'text-h4':'text-h2'} font-weight-bold error--text`" v-if="!clockedIn&&!jobComplete&&!canComplete">Not Started</span>
        <span :class="`${$vuetify.breakpoint.smAndDown?'text-h4':'text-h2'} font-weight-bold error--text`" v-if="!clockedIn&&jobComplete">Job Complete</span>
        <span :class="`${$vuetify.breakpoint.smAndDown?'text-h4':'text-h2'} font-weight-bold success--text`" v-if="clockedIn">Clocked In</span>
        <span :class="`${$vuetify.breakpoint.smAndDown?'text-h4':'text-h2'} font-weight-bold error--text`" v-if="!clockedIn&&(((job.applicants||{})[currentUser.uid]||{}).clockLog||false)">Clocked Out</span>
      </v-col>
      <v-col cols="12" align="center" class="pt-8 pb-0">
        <span>Total Time Worked</span>
      </v-col>
      <v-col cols="12" align="center" class="py-2">
        <span class="text-h2">{{totalSecondsWorked+secondsWorked|formatHoursWorked}}:{{totalSecondsWorked+secondsWorked|formatMinWorked}}:{{totalSecondsWorked+secondsWorked|formatSecWorked}}</span>
      </v-col>
      <v-col cols="12" align="center" class="pt-0">
        <span>{{job.hours}} Hour Shift</span>
      </v-col>
      <v-col cols="10" v-if="(((job.applicants||{})[currentUser.uid]||{}).clockLog||false)&& $vuetify.breakpoint.mdAndUp">
        <span>Current Shift</span>
        <v-card outlined width="100%">
          <v-list single-line>
            <template v-for="(item, index) in ((job.applicants||{})[currentUser.uid]||{}).clockLog">
              <v-list-item :key="index">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters>
                      <v-col cols="1">
                        {{item.state}}:
                      </v-col>
                      <v-col cols="11" class="pl-2">
                        {{item.date|formatTime}} ({{item.date|formatDateTime}})
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-row style="position:fixed;bottom:75px; width:100%">
      <v-col cols="12">
        <v-btn :disabled="clockedIn || status=='Applied'|| jobComplete" @click="clockIn" color="success" :height="`${$vuetify.breakpoint.smAndDown?'48':'56'}`" block>Clock-In</v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn :disabled="!clockedIn || status=='Applied'" @click="clockOut" color="error" :height="`${$vuetify.breakpoint.smAndDown?'48':'56'}`" block>Clock-Out</v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn :disabled="!canComplete" @click="endShift" color="primary" :height="`${$vuetify.breakpoint.smAndDown?'48':'56'}`" block>end shift</v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {

  },
  props: ['job', 'clockedIn', 'status', 'lastClock', 'canComplete', 'totalSecondsWorked'],
  data () {
    return {
      index: 0,
      interval: null,
      secondsWorked: 0,
      thisLog: {
        hours: 0,
        reason: ''
      }
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser']),
    jobComplete () {
      return !(this.job || {}).repeat && (this.status === 'Paid' || this.status === 'Pending Payment' || this.status === 'Completed')
    }
  },
  mounted: function () {
    if (this.job._key !== 'undefined' && this.interval == null) {
      this.interval = setInterval(() => {
        this.updateTime()
      }, 1000)
    }
  },
  destroyed () {
  },
  methods: {
    editTime () {
      this.thisLog.secondsWorked = parseFloat(this.thisLog.hours) * 3600
      this.thisLog.manualTime = true
      this.thisLog.shiftDate = this.shiftDate ? new Date(moment(this.shiftDate)) : new Date(moment())
      var updates = {}
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog/${this.thisLog._key}`] = this.thisLog
      fb.database.ref().update(updates)
      this.thisLog = {
        hours: 0,
        reason: ''
      }
      this.manualTimeDialog = false
    },
    sendPaymentReminder () {
      var notification = {
        'notificationType': 'Payment Reminder',
        'notificationText': [`${this.userProfile.public.name} is requesting a payment for ${this.job.title}`],
        'notificationDate': new Date(),
        'jobId': this.job._key,
        'defaultTab': 'Payouts'
      }
      var updates = {}
      updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/pendingPayment/${this.currentUser.uid}`] = true
      // updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/paymentRequested`] = true
      fb.database.ref(`/user/${this.job.createdBy}/profile/notifications`).push(notification)
      fb.database.ref().update(updates)
      this.paymentReminderDialog = false
    },

    startShiftFixed () {
      var updates = {}

      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockedIn`] = true
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Started'
      updates[`user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Started'

      fb.database.ref().update(updates)
      this.snackbar.message = this.$language.jobDetails['Shift Started']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    },
    completeShiftFixed () {
      var newKey = fb.database.ref().child(`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog`).push().key
      var updates = {}
      var shift = {
        _key: newKey,
        logTitle: 'Shift Completed',
        shiftDate: new Date(),
        status: 'pending',
        expenses: this.job.applicants[this.currentUser.uid].expenses
      }
      var notification = {
        'notificationType': 'Shift Completed',
        'notificationText': [`${this.userProfile.public.name} completed a shift for ${this.job.title}`],
        'notificationDate': new Date(),
        'jobId': this.job._key,
        'defaultTab': 'Payouts'
      }
      updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockedIn`] = false
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/expenses`] = null
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Pending Payment'
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog/${newKey}`] = shift
      updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/pendingPayment/${this.currentUser.uid}`] = true
      fb.database.ref().update(updates)
      this.snackbar.message = this.$language.jobDetails['Shift Complete']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    },
    handleShiftStart () {
      this.clockIn()
      this.shiftStartDialog = false
    },
    endShift () {
      var newKey = fb.database.ref().child(`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog`).push().key
      var updates = {}
      var shift = {
        _key: newKey,
        logTitle: 'Shift Completed',
        shiftDate: new Date(),
        clockLog: this.job.applicants[this.currentUser.uid].clockLog,
        secondsWorked: this.job.applicants[this.currentUser.uid].secondsWorked,
        status: 'pending'
      }
      var notification = {
        'notificationType': 'Shift Completed',
        'notificationText': [`${this.userProfile.public.name} completed a shift for ${this.job.title}`],
        'notificationDate': new Date(),
        'jobId': this.job._key,
        'defaultTab': 'Payouts'
      }
      if (!this.job.repeat) {
        updates[`jobs/${this.job._key}/public/status`] = 'Pending Payment'
        updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/status`] = 'Pending Payment'
      }
      updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockLog`] = null
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/canComplete`] = false
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/secondsWorked`] = 0
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/totalSecondsWorked`] = parseInt(this.totalSecondsWorked) + parseInt(this.secondsWorked)
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog/${newKey}`] = shift
      updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/pendingPayment/${this.currentUser.uid}`] = true
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Pending Payment'
      updates[`user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Pending Payment'
      fb.database.ref().update(updates)
      this.secondsWorked = 0
      this.endShiftDialog = false
      this.$emit('close-time')
    },
    handleShowExpensesPrompt () {
      this.showExpensesForm = true
      this.showExpensePrompt = false
      this.expensesSummary = ''
      this.expenses = 0
    },
    cancelExpenseForm () {
      this.showExpensesForm = false
      this.showExpensePrompt = true
      this.expensesSummary = ''
      this.expenses = 0
      this.completeDialog = false
    },
    updateTime () {
      if ((this.lastClock || []).state === 'in') {
        if ((((this.job || {}).applicants || {})[this.currentUser.uid] || {}).secondsWorked) {
          this.secondsWorked = moment(new Date()).diff(this.lastClock.date, 'seconds') + this.job.applicants[this.currentUser.uid].secondsWorked
        } else {
          this.secondsWorked = moment(new Date()).diff(this.lastClock.date, 'seconds')
        }
      } else if ((this.lastClock || []).state === 'out') {
        this.secondsWorked = this.job.applicants[this.currentUser.uid].secondsWorked
      }
    },
    clockIn () {
      var newKey = fb.database.ref().child(`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockLog`).push().key
      var updates = {}
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockedIn`] = true
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/canComplete`] = false
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Started'
      updates[`user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Started'
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockLog/${newKey}`] = {
        state: 'in',
        date: new Date()
      }
      fb.database.ref().update(updates)
    },
    clockOut () {
      var outDate = new Date()
      var newKey = fb.database.ref().child(`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockLog`).push().key
      var updates = {}
      var last = this.lastClock
      this.secondsWorked = this.job.applicants[this.currentUser.uid].secondsWorked ? parseInt(this.job.applicants[this.currentUser.uid].secondsWorked) + parseInt(moment(outDate).diff(last.date, 'seconds')) : moment(outDate).diff(last.date, 'seconds')
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/secondsWorked`] = this.secondsWorked
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/canComplete`] = true
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockedIn`] = false
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockLog/${newKey}`] = {
        state: 'out',
        date: outDate
      }
      fb.database.ref().update(updates)
    },
    async startJob () {
      this.buttonLoading = true
      fb.geoFireApp.set(this.job._key, null)
      var updates = {}
      var updatedDate = new Date()
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Started'
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/updatedDate`] = updatedDate
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Started'
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/updatedDate`] = updatedDate
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/startedOn`] = updatedDate
      updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/status`] = 'Started'

      var newKey = fb.database.ref().child(`jobs`).push().key
      var notification = {
        'notificationType': 'Job Started',
        'notificationText': `${this.userProfile.public.name} has CLOCKED IN for ${this.job.title}`,
        'notificationDate': updatedDate,
        'jobId': this.job._key,
        'defaultTab': 'Summary'
      }
      updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
      this.buttonLoading = false
      this.startDialog = false
      this.statusDialog = false
      this.snackbar.message = this.$language.jobDetails['You started this job.']
      this.snackbar.show = true
      this.index2 = this.index2 + 1
      await fb.database.ref().update(updates)
    },
    async completeJob () {
      if (!this.job.repeat) {
        this.buttonLoading = true
        fb.geoFireApp.set(this.job._key, null)
        var updates = {}
        var updatedDate = new Date()
        updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Pending Payment'
        updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/updatedDate`] = updatedDate
        updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/completedOn`] = updatedDate
        updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Pending Payment'
        updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/updatedDate`] = updatedDate
        // updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/status`] = 'Pending Payment'
        updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/pendingPayment/${this.currentUser.uid}`] = true
        var newKey = fb.database.ref().child(`jobs`).push().key
        var notification = {
          'notificationType': 'Job Completed',
          'notificationText': ['Worker completed your job ', this.job.title],
          'notificationDate': updatedDate,
          'jobId': this.job._key,
          'defaultTab': 'Payouts'
        }
        updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
        await fb.database.ref().update(updates)
        this.buttonLoading = false
        this.completeDialog = false
        this.statusDialog = false
        this.showExpensesForm = false
        this.showExpensePrompt = true
        this.snackbar.message = this.$language.jobDetails['You completed this job.']
        this.snackbar.show = true
        this.index2 = this.index2 + 1
      } else {
        this.completeShiftFixed()
        this.completeDialog = false
        this.showExpensesForm = false
        this.showExpensePrompt = true
      }
    },

    scrollToEnd () {
      this.$nextTick(() => {
        var container = this.$el.querySelector('.chat-container')
        if (container !== null) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    formatName (val) {
      if (val === 'Hefe') {
        return 'Hefe'
      }
      var str = (val || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    }
  },
  watch: {
  },

  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    formatHours (val) {
      if (!val) {
        return '-'
      }
      return parseFloat(val / 60 / 60).toFixed(2)
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatName (val) {
      if (val === 'Hefe') {
        return 'Hefe'
      }
      var str = (val || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    }
  }
}
</script>

<style >
.messages {
  flex-grow: 1;
  margin-bottom: 68px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  min-height: 0;
  background-color: #f2f2f2;
}
.spinner {
  margin: 0;
  width: 30px;
  text-align: center;
  color: green;
}

.spinner > div {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  background: rgb(53, 53, 53);
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
